import React, { useEffect, useRef, useState } from 'react'
import { width, height } from "../../../CustomComponents/Card/CardStyles";
import { useTranslation } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import right_dropdown_arrow from '../../../../assets/images/right_dropdown_arrow.png'
import CustomTextInput from '../../../CustomComponents/CustomtextInput';
import Loader from '../../../CustomComponents/Loader';
import Modal from '../../../CustomComponents/Modal';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../../network/NetworkUtils';
import { useNavigate, Link } from 'react-router-dom';
import { appTheme, fetchConfigarationData, retrieveData } from '../../../../helpers/utils/Utils';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../Layout/HomeLayout';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import { useKeyDown } from '../../../../hooks/useKeyDown';
import LeftBar from '../../../CustomComponents/DynamicComponent/LeftBar';
import { displayErrorMessage } from '../../../../utils';
import { DOWNLOAD_STATEMENT_OF_SELECTED_MONTH, GET_STATEMENTS_SELECTIONS, STATUS_SUCCESS_CODE, STATUS_SUCCESS_CODE_PDF_DOWNLOAD, ISDEV_ENV, GET_ACTIVITY_PRIVACY_POLICY } from '../../../../network/URLConstants';
import CustomDropdown from '../../../CustomComponents/CustomDropDown';
import arrow from '../../../../assets/images/Caret_S.png';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import CardHeading from '../../../CustomComponents/CardHeading';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';


const appConfigData = await fetchConfigarationData();

const KudzuStatements = ({ transactionDatas, onViewAllClick, viewAll }) => {

    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_kudzu_statements'));

    const [height, setHeight] = useState(0);
    const appConfigData = useSelector(state => state.appConfigData);
    const dispatch = useDispatch();
    const [iframeHeight, setIframeHeight] = useState(0);
    const userId = useSelector(state => state.userId);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const cardsListWithEnabledStatement = cards.filter(card => card.EnableStatements === true && card.ProgramKey === 200)
        .map(card => {
            return (
                {
                    AccountName: `${card.AccountTypeName} ..${card.CardDisplayNumber.slice(card.CardDisplayNumber.length - 4, card.CardDisplayNumber.length)}`,
                    CardKey: card.CardKey
                }
            )
        }
        );


    const accessTokenToApi = useSelector(state => state.accessToken);
    const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
    const selectedItem = cards?.[0]
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const [isMobileVerificationModalOpen, setisMobileVerificationModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [showModel, setShowModel] = useState(false);
    const HeadingStyles = "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[#262B3A]";
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [type, setType] = useState('')
    const [footerMsg, setFooterMsg] = useState('');
    const [pdfData, setPdfData] = useState(null);
    const [selectedDuration, setSelectedDuration] = useState({ "CardholderStatementKey": 0, "DocumentID": '', "DisplayText": 'Select' });
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [errormessage, setErrormessage] = useState('');
    const [privacyTitle, setPrivacyTitle] = useState('');
    const [privacyContent, setPrivacyContent] = useState('');
    const [showPrivacyContent, setShowPrivacyContent] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [durationList, setDurationList] = useState([
    ]);



    useKeyDown(() => { }, ["Enter"]);

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }
    useEffect(() => {
        if (selectedAccount) getStatementsListFromServer()
    }, [selectedAccount])

    const leftBarComp = () => {
        return (
          <>
            <div className="lg:w-[260px] md:w-[183px] sm:w-[164px] w-full sm:mx-0 ml-[2.5rem]">
              <p
                className="text-white font-normal
                        lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
                        sm:leading-[30px] leading-[31px]
              font-serif-pro sm:border-b-[2.5px] sm:border-[#4B70B9] lg:pb-14 md:pb-[50px]  sm:border-opacity-[50%]
              sm:pb-[2.6rem] pb-[2.6rem] mb-10"
              >
                {t("easily_access_policy")}
              </p>
              <div className="flex flex-col gap-4 text-white w-[80%]">
                {/* smiONE Navigation */}
                <Link
                  to="/Documents/smiONE"
                  className="text-white font-bold text-[16px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                >
                  {"smiONE"}
                </Link>
              </div>
              <div className="flex pt-4 flex-col gap-4 text-white w-[80%]">
                {/* Kudzu Navigation */}
                <Link
                  to="/Documents/Kudzu"
                  className="text-white font-bold text-[16px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                >
                  {"Kudzu"}
                </Link>
                <div className="flex flex-col gap-2 ml-5 transition-all duration-300 ease-in-out">
                  {/* Statements (Current Page) */}
                  {cards?.[0]?.EnableStatements && (
                    <Link
                      to="/Documents/Kudzu/Statements"
                      className="pb-2 cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                      onClick={() => {
                        logFirebaseEvents(
                          "Documents",
                          "Statement_Clicked",
                          "Statement_Clicked",
                          "",
                          ""
                        );
                      }}
                    >
                      <p className="font-hanken-grotesk font-semibold text-[15px] text-[#94C3E8]">
                        {t("KUDZU_Statements")}
                      </p>
                    </Link>
                  )}
    
                  {/* Policies Navigation */}
                  <div className="flex flex-col gap-6">
                    <Link
                      to="/Documents/Kudzu/Policies"
                      className="font-hanken-grotesk font-semibold text-[15px] text-[#FEFAEE] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                    >
                      {t("KUDZU_Policies")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      };
    const headerContent = () => {
        return (
            // <div className="flex flex-row justify-start mx-10 items-center mt-10">
            //     <div className='ml-10'>
            //         {/* Left Text */}
            //         <p className="text-xmd ">{t("external_accounts")}</p>
            //     </div>
            // </div>
            <div className="flex flex-row justify-between mx-10 items-center mt-10">
                <div className='ml-10'>
                    <p className="text-xl "></p>
                </div>
                <div onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); }}
                    className='flex flex-row justify-end items-center mr-10 '>
                </div>
            </div>
        )
    }

    const getStatementsListFromServer = async () => {
        if (cards == undefined || cards == null || selectedAccount == null) {
            return
        }
        var url = GET_STATEMENTS_SELECTIONS + selectedAccount.CardKey;
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        setLoading(true)
        GetRequest(url, headers).then((response) => {
            var parsedResponse = JSON.parse(response)
            if (parsedResponse.ResponseCode != STATUS_SUCCESS_CODE) {
                setTimeout(() => {
                    setLoading(false)
                }, 500);
            } else {
                let responseArr = parsedResponse.Response;
                setDurationList(responseArr)
                setTimeout(() => {
                    setLoading(false)
                }, 500);
            }
        })

    }

    const onStatementDownloadClick = async () => {
        logFirebaseEvents("Statements", "View_Statement_Clicked", "View_Statement_Clicked", "","");
        if (selectedDuration.DocumentID == undefined || selectedDuration.DocumentID == 0 || !selectedAccount) {
            return
        }
        let url = (!ISDEV_ENV ? appConfigData.APP_URL : '') + DOWNLOAD_STATEMENT_OF_SELECTED_MONTH + "cardKey=" + selectedAccount?.CardKey + "&documentId=" + selectedDuration.DocumentID
        let access_token = accessTokenToApi
        var headers = {
            Authorization: 'Bearer ' + access_token,
            Accept: 'application/pdf',
        };
        setLoading(true)
        try {
            const response = await fetch(url, { method: 'GET', headers });

            if (response.ok) {
                const blob = await response.blob();
                const base64Data = await blobToBase64(blob);
                const linkSource = base64Data;
                const downloadLink = document.createElement("a");
                const fileName = `${selectedDuration.DisplayText.replace(' ', '_')}_statement.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                setLoading(false)
                setErrormessage('')
                downloadLink.click();
            } else {
                setLoading(false)
                const errorData = await response.json();
                const displayText = errorData?.Messages?.[0]?.DisplayText;
                setErrormessage(displayText);
            }
        } catch (error) {
            setLoading(false)
            console.error("bad request", error);
            setErrormessage(t('doc_not_available'))
        }


    }
    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    const downloadPdfFile = async (url, headers) => {
        const response = await fetch(url, {
            method: 'GET',
            headers: headers,
        });

        const blob = await response.blob();
        const urlObject = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = urlObject;
        link.download = 'directdeposit_form.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Open the PDF in a new hidden iframe
        const printFrame = document.createElement('iframe');
        printFrame.style.visibility = 'hidden';
        printFrame.src = urlObject;
        document.body.appendChild(printFrame);

        // Wait for the iframe to load the PDF content before triggering print
        printFrame.onload = () => {
            // Trigger the print function on the iframe
            printFrame.contentWindow.print();

            // Clean up the iframe after printing and close the popup window
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000); // Adjust the delay if needed
        };
    };
    const handleClick = () => {
        setShowPrivacyContent(false);
    }

    async function onClickRightToDispute() {
        logFirebaseEvents("Statements", "Your_Right_to_Dispute_Clicked", "Your_Right_to_Dispute_Clicked", "","");
        if (selectedItem?.CardKey == undefined) {
            return
        }
        setLoading(true);
        // var url = `${GET_ACTIVITY_PRIVACY_POLICY}?CardKey=${selectedItem?.CardKey}&ContentType=TPrivacyNoteV2`
        var url = GET_ACTIVITY_PRIVACY_POLICY + selectedItem?.CardKey + '?contentType=TPrivacyNoteV2'
        // /api/cardholders/policy/latest?CardKey=724001&ContentType=TPrivacyNoteV2
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);


        const response = await GetRequest(url, headers)

        setTimeout(() => {
            setLoading(false)
        }, 500);

        const responseObj = JSON.parse(response);
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            console.log("response getted object is", responseObj);
            let title = responseObj.Response.Title
            let content = responseObj.Response.Content
            const formattedContent = convertTextToList(content);
            setPrivacyTitle(title);
            setPrivacyContent(formattedContent);
            const contentHeight = formattedContent.split('<p>').length * 20; // Assuming 20 pixels per line
            setIframeHeight(contentHeight);
            setShowPrivacyContent(true);
        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            // alert(displayText);
        }
    }
    function convertTextToList(text) {
        
        const textColor = kudzuPlusTrue ? "white" : "black"; 
        const lines = text.split('\n');
        let result = `<div id="custom-content" style="color: ${textColor};">`;
    
        let inList = false;
        for (const line of lines) {
            if (line.trim().startsWith('•')) {
                if (!inList) {
                    result += '<ul>';
                    inList = true;
                }
                result += `<li>${line.trim().slice(1).trim()}</li>`; 
            } else {
                if (inList) {
                    result += '</ul>';
                    inList = false;
                }
                result += `<p>${line.trim()}</p>`;
            }
        }
    
        if (inList) {
            result += '</ul>';
        }
    
        result += '</div>';
        return result;
    }
    


    return (
        <HomeLayout>
            <LeftBar leftBarType='component' isPrimary={true} leftBarComp={leftBarComp()} />

            <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated 
            animate__fadeInRight '>
                <DynamicCard
                    cardWidth={width.allpolicies}
                    header={true}
                    footer={false}
                    headerContent={headerContent()}
                    CardRadius={true}
                    HeaderRadius={true}
                    isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'} 
                        HeaderContent={
                            <>
                                <CardHeading heading={t('KUDZU_Statements')} />
                            </>
                        }>

                    {/* {showPrivacyContent == false && <div>
                        <div className="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] sm:font-[600] md:font-[500]
 lg:text-[26px] md:text-[22px] 
 sm:text-[15px] text-[20px] sm:leading-[23px]
 leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
                            {t("statements")}
                        </div>

                        
                    </div>} */}
                    <div className={`flex flex-col ${kudzuPlusTrue?'':'border-t-[2.5px] border-[#A3CEBB]'} mb-10  sm:mx-0 mx-4`}></div>
                    <div className='flex flex-col justify-between'>
                        <div className='flex flex-col'>
                            <div className='flex flex-col'>

                                <div className='flex sm:w-full flex-col text-[var(--document-looking-clr)]
                                lg:text-[26px] md:text-[22px] sm:text-[18px] sm:font-[400] text-[26px]
                            lg:leading-[36px] md:leading-[31px] sm:leading-[29px] font-serif-pro
                             font-[500] md:font-[500] leading-[36px] sm:mx-0 mx-4'>{t("looking_for_a_statement")} </div>

                                <div className='md:w-[550px] sm:w-[370px] flex flex-col text-[var(--document-select-clr)] lg:text-[26px]
                                 md:text-[22px] sm:text-[20px] text-[26px]
                        lg:leading-[36px] md:leading-[31px] sm:leading-[29px] font-serif-pro 
                        font-[500] leading-[36px] sm:mx-0 mx-4 '>
                                    {t("select_the_month_and_year_of_the_statement")}
                                </div>
                            </div>

                            <div className='flex justify-center sm:mx-0 mx-4'>
                                <div className={`md:w-[70%] sm:w-[84%] w-full flex flex-col gap-8 md:my-16 mt-10
                             md:h-auto sm:h-auto h-auto sm:pb-0 mb-2`}>
                                    <div>

                                        <CustomDropdown
                                            options={cardsListWithEnabledStatement}
                                            title={t('account')}
                                            onSelect={(option) => {
                                                setErrormessage('')
                                                setSelectedAccount(option)
                                            }}
                                            selectedAccountType={selectedAccount}
                                        // hrbg='bg-dropdown-sky' 
                                        />
                                        {errormessage && <div className='mt-[10px] w-full'>
                                            {errormessage && displayErrorMessage(errormessage)}
                                        </div>}
                                    </div>
                                    <div>

                                        <CustomDropdown
                                            isScroll={false}
                                            options={durationList}
                                            title={t('year')}
                                            onSelect={(option) => {
                                                setErrormessage('')
                                                setSelectedDuration(option)
                                            }}
                                            selectedAccountType={selectedDuration} />

                                        {errormessage && <div className='mt-[10px] w-full'>
                                            {errormessage && displayErrorMessage(errormessage)}
                                        </div>}


                                        <div onClick={() => onClickRightToDispute()} className='pt-6 font-hanken-grotesk flex flex-col 
                             text-[var(--document-rightTo-clr)] lg:text-[16px] md:text-[15px] sm:text-[13px] text-[15px] font-[700] 
                             cursor-pointer sm:pb-12 pb-32'>{t('your_right_to_dispute_errors')}</div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        {/* {selectedDuration.DisplayText != 'Select' && */}
                        <div className='flex flex-col w-full items-end self-center mb-14'>
                            <button className={`font-hanken-grotesk w-auto h-auto m-5
                                         ${(selectedAccount && selectedDuration.DocumentID) ? 'text-[var(--view-statement-checked-clr)]' : 'text-[var(--document-view-clr)]'}  lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                          font-[700] cursor-pointer`}
                                disabled={(selectedAccount && selectedDuration.DocumentID) ? false : true}
                                onKeyDown={(event) => {
                                    if (event.key == "Enter") {
                                        event.preventDefault(); {
                                            if (selectedDuration.DisplayText) { onStatementDownloadClick() }
                                        }
                                    }
                                }}
                                onClick={(event) => {
                                    if (selectedDuration.DisplayText) { onStatementDownloadClick() }
                                }} style={{}}>
                                {t('view_statement')}</button>
                        </div>
                        {/* } */}

                    </div>
                    {/* {showPrivacyContent == true && <div className='flex-col justify-center sm:mx-0 '>
                        <div className='w-full flex justify-center'>
                            <div className="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] 
                                            lg:text-[26px] md:text-[22px] 
                                            sm:text-[20px] text-[20px]
                                            leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
                                {privacyTitle}
                            </div>
                        </div>
                        <div className='sm:w-full flex justify-center sm:mx-0 mx-4'>
                            <div className='sm:w-[80%] w-full lg:mb-24 md:mb-24 sm:mb-24 mb-[7rem] lg:text-[18px] 
                                    md:text-[16px] sm:text-[14px] text-[16px] font-hanken-grotesk font-[500]'
                                dangerouslySetInnerHTML={{ __html: privacyContent.replace('<br/>', '<br/><br/>') }} >
                            </div>
                        </div>
                        <div>
                            <div  className='sm:px-9 cursor-pointer flex items-center gap-2 absolute bottom-12'
                                onClick={() => handleClick()}>
                                <div><img src={Leftarrow} alt='leftArrow' /></div>
                                <p className='lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-hanken-grotesk cursor-pointer text-secondary-2 font-bold text-base'>{t('back')}</p></div>
                        </div>
                    </div>} */}
                </DynamicCard>
                {loading && <Loader />}
            </div>
            <Modal
                Fullheight={true}
                isIframe={true}
                isOpen={showPrivacyContent}
                onClose={() => { setShowPrivacyContent(false); }}
                content={
                    <div className='h-full w-full'>
                        <div className=' flex justify-center mt-20 sm:mt-0'>
                            <div className=' sm:w-[80%] w-full'>
                                <div className="font-[400]
                                     md:text-[32px] md:leading-[38px]
                                    sm:text-[18px] text-[20px] sm:leading-[24px]
                                    leading-[36px] font-serif sm:px-0 px-4 text-[var(--urRight-modal-clr)]">
                                    {privacyTitle}
                                </div>
                            </div>

                        </div>
                        <div className='sm:w-full flex justify-center w-full sm:px-0 px-4 mt-10 h-[600px] sm:h-[400px]' >
                            <div className='sm:w-[80%] h-full w-full' >
                                <iframe srcDoc={privacyContent} 
                                    title="Embedded Website" className='h-full w-full'
                                // title="Embedded Website" className='h-full w-full'
                                /></div>
                        </div>
                    </div>}
            />
        </HomeLayout >

    )
}

export default withOidcSecure(KudzuStatements);
